// extracted by mini-css-extract-plugin
export default {"invalidSerialNumber":"InvalidSerialNumber_invalidSerialNumber__ZpaoE","title":"InvalidSerialNumber_title__P5TMG","purchaseButton":"InvalidSerialNumber_purchaseButton__rmVHY"};